module.exports = __webpack_public_path__ + "img/null-page-draw.15a205fa.png";